import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useContext } from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { useFormState } from 'react-use-form-state';
import cogoToast from 'cogo-toast';
import { Button, Input, FormLabel, Textarea, Checkbox } from '@chakra-ui/react';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import * as S from './styles';
import { EApiContext } from '../../context/EApi';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RequestForm = _ref => {
  let {
    product,
    cta
  } = _ref;
  const {
    0: loading,
    1: setLoading
  } = useState(false);
  const {
    createRequest
  } = useContext(EApiContext);
  const [formState, {
    text,
    email,
    checkbox,
    number,
    textarea,
    label
  }] = useFormState({
    product: product.id
  }, {
    withIds: true
  });
  const reset = () => {
    formState.reset();
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    let formValues = _objectSpread({}, formState.values);
    delete formValues.acceptLegal;
    const req = await createRequest(formValues);
    if (!req.error) {
      setLoading(false);
      cogoToast.success('Anfrage erfolgreich versendet.', {
        position: 'bottom-center',
        hideAfter: 5,
        heading: 'Erfolg'
      });
      reset();
    } else {
      setLoading(false);
      cogoToast.error('Fehler beim Versenden der Anfrage. Bitte versuchen Sie es später erneut.', {
        position: 'bottom-center',
        hideAfter: 5,
        heading: 'Fehler'
      });
    }
  };
  const handleReset = () => {
    reset();
  };
  return ___EmotionJSX("div", {
    style: {
      textAlign: 'left'
    }
  }, cta ? ___EmotionJSX("div", {
    dangerouslySetInnerHTML: {
      __html: cta
    }
  }) : ___EmotionJSX("div", null, ___EmotionJSX("p", null, "Liebe Kundinnen und Kunden."), ___EmotionJSX("p", null, "Haben Sie etwas Sch\xF6nes in unserem virtuellen Schaufenster gefunden? Suchen Sie ein passendes Geschenk f\xFCr Ihre Liebsten?")), ___EmotionJSX(S.Form, {
    id: "int-item-request",
    name: "display-item-request",
    method: "POST",
    onReset: handleReset,
    onSubmit: handleSubmit
  }, ___EmotionJSX(Container, {
    fluid: true
  }, ___EmotionJSX("div", {
    className: "hidden"
  }, ___EmotionJSX("label", _extends({
    hidden: true
  }, label('product')), "ID"), ___EmotionJSX("input", _extends({
    type: "hidden"
  }, number('product'), {
    required: true,
    readOnly: true
  }))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX(FormLabel, label('name'), "Name*"), ___EmotionJSX(Input, _extends({
    variant: "outline"
  }, text('name'), {
    placeholder: "Max Mustermann",
    required: true
  })))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 6
  }, ___EmotionJSX(FormLabel, label('email'), "Email*"), ___EmotionJSX(Input, _extends({
    variant: "outline"
  }, email('email'), {
    placeholder: "max@mustermann.de",
    required: true
  }))), ___EmotionJSX(Col, {
    md: 6
  }, ___EmotionJSX(FormLabel, label('phone'), "Telefon"), ___EmotionJSX(Input, _extends({
    variant: "outline"
  }, number('phone'), {
    placeholder: "012345"
  })))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX(FormLabel, label('message'), "Nachricht*"), ___EmotionJSX(Textarea, _extends({}, textarea('message'), {
    placeholder: "Ich interessiere mich f\xFCr o.g. Produkt...",
    required: true
  })))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX("label", _extends({}, label('acceptLegal'), {
    className: "int-legal-checkbox-label"
  }), ___EmotionJSX(Checkbox, _extends({
    colorScheme: "brand"
  }, checkbox('acceptLegal'))), ___EmotionJSX("p", null, "*Ja, ich habe die ", ___EmotionJSX(Link, {
    to: "/datenschutz",
    target: "_blank"
  }, "Datenschutzerkl\xE4rung"), " zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage benutzt. Mit dem Absenden des Kontaktformulars erkl\xE4re ich mich mit der Verarbeitung einverstanden.")))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, null, ___EmotionJSX("div", {
    style: {
      textAlign: 'right'
    }
  }, ___EmotionJSX("div", {
    className: "int-btn-group"
  }, ___EmotionJSX(Button, {
    colorScheme: "brand",
    variant: "ghost",
    type: "reset"
  }, "Abbrechen"), ___EmotionJSX(Button, {
    colorScheme: "brand",
    type: "submit",
    disabled: !formState.values.acceptLegal || loading || !formState.values.name || !formState.values.email || !formState.values.message
  }, "Abschicken")))))), ___EmotionJSX("p", {
    style: {
      textAlign: 'right',
      fontSize: '0.8rem'
    }
  }, "* Pflichtfelder")));
};
export default RequestForm;